import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map, distinctUntilChanged } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/layout";
var BreakpointService = /** @class */ (function () {
    function BreakpointService(breakpointObserver) {
        this.breakpointObserver = breakpointObserver;
        this.isMobileView = this.breakpointObserver.observe(Breakpoints.Handset)
            .pipe(map(function (p) { return p.matches; }), distinctUntilChanged());
    }
    BreakpointService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BreakpointService_Factory() { return new BreakpointService(i0.ɵɵinject(i1.BreakpointObserver)); }, token: BreakpointService, providedIn: "root" });
    return BreakpointService;
}());
export { BreakpointService };
